import React from 'react'
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function Services() {
    const location = useLocation();
  
    useEffect(() => {
        const name = location.pathname;
        document.body.className = name.substring(1) + "-body";
    }, [location]);
  return (
    <div className="service container">
    <h1 className="service-h1 text-center"> ComTech’s Services </h1>


    <div className="row  justify-content-between  ">
        <div className=" d-flex flex-column col-lg-4 col-md-12 col-sm-12  col-12">
            <div
                className="d-flex align-items-center justify-content-lg-between justify-content-center  main-services-dashed w-100 ">

                <div className="service-element-round">
                    <div></div>

                </div>
                <div
                    className="left-side-service d-flex flex-column justify-content-center mb-lg-0 mt-md-4 mb-md-0 mt-sm-3 mb-sm-0 mt-lg-3 mb-xl-1 mt-xl-0 mt-0 mb-3">
                    <div className="service-heading text-center">Basic Package</div>
                    <div className="dashed-border mb-sm-5 mb-md-5 mb-xl-4 "></div>
                </div>
            </div>


            <div
                className="service-div bggradient service-package mb-sm-4 mb-4 w-md-75 w-sm-75 w-lg-auto w-auto align-self-lg-auto align-self-md-center align-self-sm-center align-self-auto service-pm  ">

                <ul>
                    <li>API for Buy / Sell</li>
                    <li>API for Price Feed</li>
                    <li>API for APP
                        <ul className='list-unstyled p-0'>
                            <li className="custom-dash">API for SIP</li>
                            <li className="custom-dash">API for Redeem</li>
                            <li className="custom-dash">API for Gift</li>
                        </ul>
                    </li>
                    <li>Create your own gold token</li>
                    <li>Integrated tokenization platform</li>
                    <li>Physical assets secured with tradeflow warrants</li>
                    <li>Tech support</li>
                </ul>
            </div>
        </div>




        <div className="d-flex flex-column col-lg-4 col-md-12 col-sm-12  col-12">

            <div
                className="d-flex align-items-center justify-content-lg-between justify-content-center w-100 main-services-dashed ">

                <div className="service-element-round">
                    <div></div>

                </div>
                <div
                    className="left-side-service d-flex flex-column justify-content-center mb-lg-0 mt-md-4 mb-md-0 mt-sm-3 mb-sm-0 mt-lg-3 mb-xl-1 mt-xl-0 mt-0 mb-3">
                    <div className="service-heading text-center">Standard Package</div>
                    <div className="dashed-border mb-sm-5 mb-md-5 mb-xl-4 "></div>
                </div>
            </div>
            <div
                className="service-div bggradient service-package mb-sm-4 mb-4 service-pm w-md-75 w-sm-75 w-lg-auto w-auto align-self-lg-auto align-self-md-center align-self-sm-center align-self-auto">
                <ul>
                    <li>All Whitelabel Package 1 features.</li>
                    <li>Custody Support
                    <ul className='list-unstyled p-0'>
                            <li className="custom-dash">Digital custody of tokens</li>
                            <li className="custom-dash">Physical custody of assets</li>
                        </ul>
                    </li>
                    <li>Security and Insurance
                    <ul className='list-unstyled p-0'>
                            <li className="custom-dash">Digital tokens</li>
                            <li className="custom-dash">Physical assets</li>
                        </ul>
                    </li>
                    <li>Pledging of physical custody using tradeflow warrants</li>
                    <li>OTC Deals</li>
                    <li>Minting & Burning of tokens using Multi-Sig</li>
                    <li>Tie-ups with distribution vendors for physical assets</li>
                </ul>
            </div>
        </div>



        <div className="d-flex flex-column col-lg-4 col-md-12 col-sm-12  col-12">

            <div
                className="d-flex align-items-center justify-content-lg-between justify-content-center w-100 main-services-dashed ">

                <div className="service-element-round">
                    <div></div>

                </div>
                <div
                    className="left-side-service d-flex flex-column justify-content-center mb-lg-0 mt-md-4 mb-md-0 mt-sm-3 mb-sm-0 mt-lg-3 mb-xl-1 mt-xl-0 mt-0 mb-3">
                    <div className="service-heading text-center">Premium Package</div>
                    <div className="dashed-border mb-sm-5 mb-md-5 mb-xl-4 "></div>
                </div>
            </div>

            <div
                className="service-div bggradient service-package mb-sm-4 mb-4 service-pm w-md-75 w-sm-75 w-lg-auto w-auto align-self-lg-auto align-self-md-center align-self-sm-center align-self-auto">
                <ul >
                    <li>Custody Support
                    <ul className='list-unstyled p-0'>
                            <li className="custom-dash">Digital custody of tokens</li>
                            <li className="custom-dash">Physical custody of assets</li>
                        </ul>
                    </li>
                    <li>Security and Insurance
                    <ul className='list-unstyled p-0'>
                            <li className="custom-dash">Digital tokens</li>
                            <li className="custom-dash">Physical assets</li>
                        </ul>
                    </li>
                    <li>Pledging of physical custody using tradeflow warrants</li>
                    <li>OTC Deals</li>
                    <li>Minting & Burning of tokens using Multi-Sig</li>
                    <li>Tie-ups with distribution vendors for physical assets</li>
                </ul>
            </div>
        </div>
    </div>
</div>
  )
}

export default Services
